import {
  Agandeform,
  Kategori,
  BostadsinformationDto,
  VarderingParametrarDto,
  BostadsvarderingDto,
} from '../types/dtos/VarderingarModel';

const agandeformToBostadskategori = (agandeform?: Agandeform): Kategori => {
  switch (agandeform) {
    case Agandeform.bostadsrätt:
      return Kategori.BOSTADSRATT;
    case Agandeform.äganderätt:
    case Agandeform.tomträtt:
      return Kategori.SMAHUS;
    case Agandeform.okänd:
    case Agandeform.hyresrätt:
    default:
      return undefined;
  }
};

export const createVarderingParametrar = (
  bostadsInfo: BostadsinformationDto,
  vardering: BostadsvarderingDto
): VarderingParametrarDto => {
  return {
    id: '',
    adress: {
      gata: bostadsInfo?.adress,
      lagenhetsnummer: bostadsInfo?.lagenhetsnummer,
      postnummer: bostadsInfo?.postnummer,
      postort: bostadsInfo?.postort,
    },
    sweref99x: bostadsInfo?.sweref99x,
    sweref99y: bostadsInfo?.sweref99y,
    kategori: agandeformToBostadskategori(bostadsInfo?.agandeform),
    antalRum: bostadsInfo?.antalRum,
    boarea: bostadsInfo?.boarea,
    biarea: vardering?.parametrar?.biarea,
    tomtarea: vardering?.parametrar?.tomtarea,
    byggar: bostadsInfo?.byggar,
    avgift: vardering?.parametrar?.avgift,
    vaning: vardering?.parametrar?.vaning,
    antalVaningar: vardering?.parametrar?.antalVaningar,
    standardpoang: vardering?.parametrar?.standardpoang,
  };
};
